import {audioFiles} from 'audioFiles'
import {Howl, Howler} from 'howler'
import {captions} from '../captions'

let tracks = {
  vo: [],
  sfx: [],
  music: [],
  ambience: []
}

function mute() {
  Howler.volume(0)
  document.querySelectorAll('video').forEach( (video) => {
    video.muted = true
  })
}

function unmute() {
  Howler.volume(1)
  document.querySelectorAll('video').forEach( (video) => {
    video.muted = false
  })
}

function loadAudioObj(obj) {
  if( obj.hasOwnProperty('howl') ) {
    console.log('Already loaded: ', obj)
    return
  }
  const loop = obj.hasOwnProperty('loop') ? obj.loop : false
  const filePath = '../media/'
  if( obj.hasOwnProperty('file') ) {
    obj.howl = new Howl({
      src: filePath + obj.file,
      html5: false,
      loop: loop
    })
  }
  if( obj.hasOwnProperty('files') ) {
    for(var a = 0; a < obj.files.length; a++) {
      obj.files[a].howl = new Howl({
        src: filePath + obj.files[a].file,
        loop: loop
      })
    }
  }
  return obj
}

// load all audio (fired only on start)
function loadAudio() {
  let sceneNames = Object.keys(audioFiles)
  for(let i = 0; i < sceneNames.length; i++) {
    let sceneName = sceneNames[i]
    let scene = audioFiles[ sceneName ]
    let fileNames = Object.keys(scene)
    for(let k = 0; k < fileNames.length; k++) {
      let fileName = fileNames[k]
      let file = audioFiles[sceneName][fileName]
      file = loadAudioObj(file)
    }
  }
}

function removeAudioFromTrack(trackName, fileName) {
  let track = tracks[trackName]
  for(var i = 0; i < track.length; i++) {
    const audio = track[i]
    if(audio.refName === fileName) {
      track.splice(i, 1)
    }
  }
}

function stopTrack(trackName) {
  let audios = tracks[trackName]
  for(var i = 0; i < audios.length; i++) {
    let audio = audios[i]
    audio.howl.stop()
    if( audio.hasOwnProperty('onEndOrInterrupt') ) {
      if(audio.played !== true) {
        audio.played = true
        audio.onEndOrInterrupt()
      }
    }
    tracks[trackName].splice(i, 1)
  }
}

function getAudio(fileName) {

  // locate file from files object
  const locationNames = fileName.split('\/')
  let audioObj = audioFiles
  for(var k = 0; k < locationNames.length; k++) {
    let locationName = locationNames[k]
    audioObj = audioObj[locationName]
  }
  return audioObj

}

function playAudio(fileNames, props = null) {

  // if src is a string, convert to array
  if( ! Array.isArray(fileNames) ) {
    fileNames = [fileNames]
  }

  function fileIterator(i) {
    const fileName = fileNames[i]

    let audioObj = getAudio(fileName)

    // if object has multiple files, pick a random one
    let parentObj = {}
    if(audioObj.files) {
      parentObj = audioObj
      const numberOfFiles = audioObj.files.length - 1
      const fileNumber = Math.floor(Math.random() * Math.floor(numberOfFiles) );
      audioObj = audioObj.files[fileNumber]
    }

    // check for howler
    if(! audioObj.hasOwnProperty('howl') ) {
      audioObj = loadAudioObj(audioObj)
    }

    // add name of referenced file, for removal
    audioObj.refName = fileName

    // if it's a VO track, stop other VO
    if(audioObj.track == "vo") {
      stopTrack('vo')
    }

    // store the onEndOrInterrupt for later in case the file gets interrupted
    if( props && props.hasOwnProperty('onEndOrInterrupt') ) {
      audioObj.onEndOrInterrupt = props.onEndOrInterrupt
    }

    // set CC text
    const ccText = audioObj.alt || ""

    // play audio
    const delay = audioObj.delay || parentObj.delay || 0
    setTimeout( () => {
      if(audioObj.track == "vo") {
        captions(ccText)
      }
      audioObj.howl.play()
    }, delay)

    // add to audio track
    if( audioObj.hasOwnProperty('track') ) {
      tracks[audioObj.track].push(audioObj)
    }

    // on end, play next file or run callback
    audioObj.howl.on('end', () => {
      if(audioObj.loop) {
        return
      }
      audioObj.played = true
      removeAudioFromTrack(audioObj.track, fileName)
      const startNext = audioObj.startNext || 0
      setTimeout( () => {
        if( fileNames[i + 1] ) {
          fileIterator(i + 1)
        }
        else {
          if( props !== null ) {
            if( props.hasOwnProperty('onEnd') ) {
              props.onEnd()
            }
            if( props.hasOwnProperty('onEndOrInterrupt') ) {
              props.onEndOrInterrupt()
            }
          }
        }
      }, startNext)
    })

  }

  // play first file
  fileIterator(0)
}

export {loadAudio, getAudio, playAudio, stopTrack, mute, unmute}
